import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ComponentIterator from '../../containers/ComponentIterator';

class ReusableComponent extends Component {
  componentDidMount() {}

  render() {
    const { children, components } = this.props;

    return (
      <ComponentIterator components={components} />
    );
  }
}

ReusableComponent.propTypes = {
  children: PropTypes.shape().isRequired,
};

ReusableComponent.defaultProps = {

};

export default ReusableComponent;
